module.exports = __webpack_public_path__ + "static/images/electronics.13dt4PO.svg";